import request from '@/utils/request'

// 角色分页列表
export function getRoleList(params) {
  return request({ url: '/api/role/list', method: 'get', params })
}

// 新增角色
export function addRole(data) {
  return request({ url: '/api/role', method: 'post', data })
}

// 编辑角色
export function updateRole(data) {
  return request({ url: '/api/role', method: 'put', data })
}

// 删除角色
export function deleteRole(id) {
  return request({ url: `/api/role/${id}`, method: 'delete' })
}

// 分配菜单权限（roleId 作为 query 参数，menuIds 作为 body 数组）
export function assignMenus(roleId, menuIds) {
  return request({
    url: '/api/role/assignMenus',
    method: 'put',
    params: { roleId },
    data: menuIds
  })
}
